import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, Renderer2 } from '@angular/core';
import { Router } from '@angular/router';
interface ChatMessage {
  sender: string;
  content: string;
  timestamp: string;
  isDate?: boolean;
}
@Component({
  selector: 'app-pop-up-chat',
  templateUrl: './pop-up-chat.component.html',
  styleUrls: ['./pop-up-chat.component.scss']
})
export class PopUpChatComponent implements OnInit, OnDestroy {

  constructor(
    private router: Router,
    private renderer: Renderer2,
  ) { }


  @Output() onCloseEvent = new EventEmitter<any>();
  messages: ChatMessage[] = [];
  newMessage: string = '';
  @Input() param: any;

  //   newMessage :any = {
  //   // lable: 'Invoice Number',
  //     formControlName: 'newMessage',
  //     dataField: 'newMessage',
  //   isRequired: false,
  //   placeholder: 'Write a message...',
  //     type:'textarea'
  // };

  ngOnInit() {
    this.addInitialMessages();
    this.renderer.addClass(document.body, 'modal-sm-override-PopChats');
  }


  ngOnDestroy(): void {
    this.renderer.removeClass(document.body, 'modal-sm-override-PopChats');
  }


  addInitialMessages() {
    const initialMessages: ChatMessage[] = [
      { sender: 'Austin Thurston', content: 'Hey, good morning...how are you?', timestamp: '9:45 am' },
      { sender: 'You', content: 'Hello, good morning', timestamp: '9:48 am' },
      // { sender: 'You', content: "I'm Great. how about you?", timestamp: '9:48 am' },
      // { sender: 'Austin Thurston', content: "I'm good too.", timestamp: '10:02 am' },
      // { sender: 'Austin Thurston', content: 'I want to know how to create cash receipt in the website and manage it?', timestamp: '10:04 am' },
      // { sender: 'You', content: 'Okay..', timestamp: '10:10 am' },
      // { sender: 'You', content: 'I will arrange meeting at 2:00pm on zoom, our service representative @austinthurston will guide you for your queries.', timestamp: '10:10 am' },
      // { sender: 'Austin Thurston', content: 'Okay, Thanks', timestamp: '10:15 am' },
      // { sender: 'You', content: 'I will share the meeting link shortly', timestamp: '10:16 am' },
      // { sender: 'Austin Thurston', content: 'Okay', timestamp: '10:17 am' },
    ];

    this.addDateSeparator();
    this.messages.push(...initialMessages);
  }


  addDateSeparator() {
    const today = new Date().toLocaleDateString('en-IN', { weekday: 'long', month: 'long', day: 'numeric' });
    this.messages.push({ sender: '', content: today, timestamp: '', isDate: true });
  }

  sendMessage() {
    if (this.newMessage.trim()) {
      this.messages.push({
        sender: 'You',
        content: this.newMessage,
        timestamp: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
      });
      this.newMessage = '';
    }
  }


  goToHomePage() {
    this.onCloseEvent.emit();
    this.param = {};
  }
}
